import { VuexModule, Module, getModule, Mutation } from 'vuex-module-decorators'
import store from '../index'

@Module({
    name: 'newReview',
    dynamic: true,
    namespaced: true,
    store
})
export default class NewReview extends VuexModule {
    public stepsActive = 0

    @Mutation
    setStepsAvtive(val: number) {
        this.stepsActive = val
    }
}

export const NewReviewModule = getModule(NewReview)